import { render } from "./Clock.vue?vue&type=template&id=79002930"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"
script.render = render

export default script